import React, { ReactNode } from 'react';

import Table from '../../components/table';
import type { RowData } from '../../components/table';

interface ManageUsersTableProps {
  data: RowData[];
  noRowsValue: ReactNode;
}

const ManageUsersTable: React.FC<ManageUsersTableProps> = ({ data, noRowsValue }) => {
  const headers = [
    { header: 'Username' },
    { header: 'Email Address' },
    { header: 'Status' },
    { header: 'Role' },
  ];
  return <Table headers={headers} data={data} noRowsValue={noRowsValue} />;
};

export default ManageUsersTable;
